module.exports = __webpack_public_path__ + "static/media/bosnia.105a35e6.png";